import { defineMessages } from 'react-intl-next';
export var messages = defineMessages({
  beta: {
    id: 'betaTag',
    defaultMessage: 'Beta',
    description: 'A tag to indicate the search experience is in Beta.'
  }
});